<template>
    <b-modal
        id="defect-description-modal"
        size="lg"
        title="Defect description required"
        no-close-on-backdrop
        no-close-on-esc>
        <p>The defect description is missing for this device. It is required before the repair can be completed, please add it below.</p>

        <div class="form-group">
            <label>Fault description</label>
            <textarea v-model="description" class="form-control" rows="3" maxlength="300" placeholder="Enter a description"></textarea>
            <p class="text-left text-muted text-xs pl-1 mb-0">Enter a minimum of 20 characters</p>
        </div>

        <div class="form-group">
            <label>Fault occurrence frequency</label>
            <select v-model="frequency" class="custom-select">
                <option :value="null">Select frequency of occurrence</option>
                <option value="Always">Always</option>
                <option value="More than once a day">More than once a day</option>
                <option value="Once a day">Once a day</option>
                <option value="Intermittent">Intermittent</option>
            </select>
        </div>

        <template v-slot:modal-footer>
            <button type="button" class="btn btn-light" :disabled="saving" @click="$bvModal.hide('defect-description-modal')">Cancel</button>
            <button type="button" class="btn btn-success" :disabled="!canSave || saving" @click="save()">Save and continue</button>
        </template>
    </b-modal>
</template>

<script>
import {mapActions} from "vuex";

export default {
    props: ["deviceId"],

    data() {
        return {
            description: "",
            frequency: null,
            saving: false
        }
    },

    computed: {
        canSave() {
            return !!this.description && this.description.trim().length >= 20 && !!this.frequency;
        }
    },

    methods: {
        ...mapActions([
            "displayToast",
            "setDefectDescriptions"
        ]),

        save() {
            this.saving = true;

            this.setDefectDescriptions({
                deviceId: this.deviceId,
                description: this.description.trim(),
                frequency: this.frequency
            }).then(() => {
                this.$bvModal.hide('defect-description-modal');
                this.$emit('saved');
            }).catch(() => {
                this.displayToast({text: 'Unable to save the defect description, please try again.', type: 'danger'});
            }).finally(() => {
                this.saving = false;
            });
        }
    }
}
</script>
